module.exports = __webpack_public_path__ + "img/352a70a04cdd4b862d4042a5a8485e9d.jpg";